import { getLocalizedStringValue } from '@griply/utils';
import { useMemo } from 'react';
import { useLifeAreaByIdQuery } from 'shared/hooks/queries/use-life-area-by-id-query';
import { useUser } from 'shared/hooks/use-user';
import { useI18nLocale } from 'shared/lib/react-i18next/use-i18n-locale';
import { ID } from 'shared/types/id';
import { LifeArea } from 'shared/types/life-area';

export const useLocalizedLifeAreaById = (id?: ID) => {
  const locale = useI18nLocale();
  const user = useUser();
  const { data } = useLifeAreaByIdQuery(user?.uid, id);

  return useMemo<LifeArea | undefined>(
    () =>
      data
        ? { ...data, name: getLocalizedStringValue(data?.name, locale) }
        : undefined,
    [data, locale],
  );
};
